module.exports = __webpack_public_path__ + "img/reset_switch_step_1.0462f3bd.png";